import { useEffect, useRef } from "react";
import { useMotionValue, useSpring, useTransform, motion } from "framer-motion";

const InteractiveStage = ({ children, className = "", onActivate }) => {
  const ref = useRef(null);
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const sx = useSpring(mx, { stiffness: 90, damping: 16 });
  const sy = useSpring(my, { stiffness: 90, damping: 16 });

  const tiltX = useTransform(sy, (v) => Math.max(-14, Math.min(14, v * -0.045)));
  const tiltY = useTransform(sx, (v) => Math.max(-14, Math.min(14, v * 0.045)));
  const shiftX = useTransform(sx, (v) => v * 0.04);
  const shiftY = useTransform(sy, (v) => v * 0.04);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const onMove = (e) => {
      const r = el.getBoundingClientRect();
      mx.set(e.clientX - (r.left + r.width / 2));
      my.set(e.clientY - (r.top + r.height / 2));
    };
    const onLeave = () => {
      mx.set(0);
      my.set(0);
    };
    el.addEventListener("pointermove", onMove);
    el.addEventListener("pointerleave", onLeave);
    return () => {
      el.removeEventListener("pointermove", onMove);
      el.removeEventListener("pointerleave", onLeave);
    };
  }, [mx, my]);

  return (
    <div
      ref={ref}
      className={`scene ${className}`}
      onClick={onActivate}
      role={onActivate ? "button" : undefined}
      tabIndex={onActivate ? 0 : undefined}
      onKeyDown={
        onActivate
          ? (e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onActivate();
              }
            }
          : undefined
      }
    >
      <motion.div
        className="scene__rig"
        style={{ x: shiftX, y: shiftY, rotateX: tiltX, rotateY: tiltY }}
      >
        {children}
      </motion.div>
    </div>
  );
};

export default InteractiveStage;
